export abstract class NgParamService {
    abstract get(id: string|number): any;
    abstract set(param: any, id?: string|number): string;
}
